import { useContext } from 'react'
import { AnalyticsContext } from 'contexts'

/** @typedef {import("../types").IUseAnalyticsReturn} AR */
/** @returns {AR} */
export default function useAnalytics() {
  const contextData = useContext(AnalyticsContext)


  return contextData
}
